export const SOURCES = {
  CALENDAR: {
    MONTH: 'calendarMonth',
    WEEK: 'calendarWeek',
    DAY: 'calendarDay',
    TEAM: 'calendarTeam',
    TASK_PLANNER: 'calendarTaskPlanner',
    DEADLINE: 'calendarDeadline',
  },
  CALL: {
    DETAIL: 'callDetail',
    FORM: 'callForm',
    CONFIRM_DELETE_FORM: 'callConfirmDeleteForm',
    OVERVIEW: 'callOverview',
    STARTED_CHANGING_OWNER: 'call.startedChangingOwner',
    STARTED_DELETING_SEGMENT: 'call.startedDeletingSegment',
    LOG_SCREEN: 'callLogScreen',
    MARKED_AS_DONE_CONFIRMATION_SCREEN: 'callMarkedAsDoneConfirmationScreen',
  },
  COMPANY: {
    COMPANY: 'company',
    ACTIVE_PROJECTS: 'companyActiveProjects',
    ACTIVITY_FEED: 'companyActivityFeed',
    BACKGROUND_INFORMATION_DIALOG: 'companyBackgroundInformationDialog',
    DEAL_ACTIONS: 'companyDealActions',
    DEAL_DETAIL: 'companyDealDetail',
    DETAIL: 'companyDetail',
    FORM: 'companyForm',
    INVOICE_PREFERENCES_FORM: 'companyInvoicePreferencesForm',
    LINK_TO_CONTACT_FORM: 'companyLinkToContactForm',
    OVERVIEW: 'companyOverview',
    UNBILLED_TIME_WIDGET: 'companyDetailUnbilledTime',
    DETAIL_UNEXPECTED_ERROR_PAGE: 'companyDetailUnexpectedErrorPage',
    CUSTOMIZE_PAGE: 'customizeCompanyPagePage',
  },
  CONTACT: {
    ACTIVE_PROJECTS: 'contactActiveProjects',
    ACTIVITY_FEED: 'contactActivityFeed',
    BACKGROUND_INFORMATION_DIALOG: 'contactBackgroundInformationDialog',
    DEAL_ACTIONS: 'contactDealActions',
    DEAL_DETAIL: 'contactDealDetail',
    DETAIL: 'contactDetail',
    FORM: 'contactForm',
    LINK_TO_COMPANY_FORM: 'contactLinkToCompanyForm',
    OVERVIEW: 'contactOverview',
    UNBILLED_TIME_WIDGET: 'contactDetailUnbilledTime',
    DETAIL_UNEXPECTED_ERROR_PAGE: 'contactDetailUnexpectedErrorPage',
    CUSTOMIZE_PAGE: 'customizeContactPagePage',
  },
  CREDIT_NOTE: {
    OVERVIEW: 'creditNoteOverview',
  },
  CUSTOMER_MEETING: {
    PROMOTIONAL_PAGE: 'customerMeetingPromotionalPage',
    CONTACT_FORMS_LANDING_PAGE: 'contactFormsLP',
  },
  DASHBOARD: 'dashboard',
  DEAL: {
    PIPELINE_SETTINGS: 'dealPipelineSettings',
    PIPELINE_VIEW: 'dealPipelineView',
    DETAIL: 'dealDetail',
    DETAIL_ACTIONS: 'dealDetailActions',
    FOLLOW_UP_WIDGET: 'dealFollowUpWidget',
    FORM: 'dealForm',
    INSIGHTS: 'dealInsights',
    OVERVIEW: 'dealOverview',
    MULTIPLE_DEAL_PIPELINES_UPSELL_DIALOG: 'multipleDealPipelinesUpsellDialog',
    UNLIMITED_DEAL_PIPELINES_UPSELL_DIALOG: 'unlimitedDealPipelinesUpsellDialog',
  },
  DELIVERY_NOTE: {
    OVERVIEW: 'deliveryNoteOverview',
  },
  DOCUMENT_LINES: {
    FORM: 'documentLinesForm',
  },
  FOOTER: 'footer',
  GLOBAL_SEARCH: 'globalSearch',
  HR: {
    OVERVIEW_USERS: 'hrOverviewUsers',
    USER_SETTINGS_FORM: 'userSettingsForm',
    SEND_INVITE_DIALOG: 'sendInviteDialog',
    USER_ACTIONS: 'userActions',
  },
  INSIGHTS: {
    PIPELINE: 'insights.pipeline',
    INVOICES: 'insights.invoices',
  },
  INVOICE: {
    OVERVIEW: 'invoiceOverview',
    FORM: 'invoiceForm',
    DETAIL: 'invoiceDetail',
    PAYMENT_FORM: 'invoiceFullPaymentForm',
    SEND_FORM: 'invoiceSendForm',
    CONVERT_CURRENCY_FORM: 'invoiceConvertCurrencyForm',
    REPORT: 'invoiceReport',
    ON_DEMAND_FINANCING_WIDGET: 'onDemandFinancingWidget',
    ON_DEMAND_FINANCING_OVERVIEW_BANNER: 'onDemandFinancingOverviewBanner',
    EXPORT: 'invoiceExport',
  },
  LICENSE: {
    REQUEST_DOWNGRADE_FORM: 'licenseRequestDowngradeForm',
    REQUEST_CANCELLATION_FORM: 'licenseRequestCancellationForm',
    OVERVIEW: 'licenseOverview',
    ADD_CREDIT_CARD: 'licenseAddCreditCard',
  },
  MEETING: {
    DETAIL: 'meetingDetail',
    DETAIL_ACTIONS: 'meetingDetailActions',
    FORM: 'meetingForm',
    CONFIRM_DELETE_FORM: 'meetingConfirmDeleteForm',
    OVERVIEW: 'meetingOverview',
  },
  MILESTONE: {
    FORM: 'milestoneForm',
  },
  NAVIGATION: {
    PRIMARY_NAVIGATION: 'primaryNavigation',
    TOP_NAVIGATION: 'topNavigation',
  },
  ORDER: {
    OVERVIEW: 'orderOverview',
    FORM: 'orderForm',
    DETAIL: 'orderDetail',
    DETAIL_ACTIONS: 'orderDetailActions',
    DETAIL_CONTENTS: 'orderDetailContents',
    DETAIL_INFOWIDGET: 'orderDetailInfowidget',
  },
  ORDER_CONFIRMATION: {
    OVERVIEW: 'orderConfirmationOverview',
  },
  PRODUCT: {
    OVERVIEW: 'productOverview',
    FORM: 'productForm',
  },
  PROJECT: {
    ACTIVITY_FEED: 'projectActivityFeed',
    DETAIL: 'projectDetail',
    DETAIL_WORK_BREAKDOWN: 'projectDetailWorkBreakdown',
    DETAIL_WORK_BREAKDOWN_SIDEPANEL_TASK: 'projectDetailWorkBreakdownSidePanelTask',
    DETAIL_WORK_BREAKDOWN_SIDEPANEL_MATERIAL: 'projectDetailWorkBreakdownSidePanelMaterial',
    DETAIL_WORK_BREAKDOWN_SIDEPANEL_GROUP: 'projectDetailWorkBreakdownSidePanelGroup',
    DETAIL_WORK_BREAKDOWN_SIDEPANEL_MEETING: 'projectDetailWorkBreakdownSidePanelMeeting',
    DETAIL_INFOWIDGET: 'projectDetailInfowidget',
    DETAIL_ORDERWIDGET: 'projectDetailOrderwidget',
    EXPORT_FORM: 'projectExportForm',
    FORM: 'projectForm',
    OVERVIEW: 'projectOverview',
    REPORT_FORM: 'projectReportForm',
    INFO: 'projectInfo',
    HEADER: 'projectHeader',
    INVOICES: 'projectInvoices',
    TIMELINE: 'projectTimeline',
  },
  RECYCLE_BIN: {
    OVERVIEW_COMPANIES: 'recycleBinCompaniesOverview',
    OVERVIEW_CONTACTS: 'recycleBinContactsOverview',
    OVERVIEW_DEALS: 'recycleBinDealsOverview',
    RESTORE_DIALOGUE_NO_LINKS: 'recycleBinRestoreDialogueNoLinks',
    RESTORE_DIALOGUE_LINKS: 'recycleBinRestoreDialogueLinks',
    ANONYMISE_DIALOGUE_NO_LINKS: 'recycleBinAnonymiseDialogueNoLinks',
    ANONYMISE_DIALOGUE_LINKS: 'recycleBinAnonymiseDialogueLinks',
  },
  REFERRAL: {
    FORM: 'referralForm',
  },
  SETTINGS: {
    COMPANY_ENTITY_DIALOG: 'companyEntityDialog',
    COMPANY_ENTITY_OVERVIEW: 'companyEntityOverview',
    COMPANY_ENTITY_TERMS: 'companyEntityTerms',
    INVOICES: 'invoiceSettings',
    CUSTOM_ACTIVITY_TYPES: 'customActivityTypes',
    SECURITY: 'securitySettings',
  },
  TASK: {
    DETAIL: 'taskDetail',
    OVERVIEW: 'taskOverview',
    FORM: 'taskForm',
    CONFIRM_DELETE_FORM: 'taskConfirmDeleteForm',
  },
  TICKET: {
    OVERVIEW: 'ticketOverview',
    DETAIL: 'ticketDetail',
    FORM: 'ticketForm',
  },
  TIMETRACKING: {
    BULK_MODAL: 'timetrackingBulkModal',
    CALL_FORM: 'timetrackingCallForm',
    DETAIL: 'timetrackingDetail',
    EXPORT_FORM: 'timetrackingExportForm',
    FORM: 'timetrackingForm',
    MEETING_FORM: 'timetrackingMeetingForm',
    MULTIPLE_TIMETRACKING_UPSELL_DIALOG_FOR_ADMINS: 'timetrackingMultipleTimetrackingUpsellDialogForAdmins',
    MULTIPLE_TIMETRACKING_UPSELL_DIALOG_FOR_NON_ADMINS: 'timetrackingMultipleTimetrackingUpsellDialogForNonAdmins',
    OVERVIEW: 'timetrackingOverview',
    OVERVIEW_DAILY: 'timetrackingOverviewDaily',
    OVERVIEW_ITEM: 'timetrackingOverviewItem',
    OVERVIEW_BAR: 'timetrackingOverviewBar',
    TASK_FORM: 'timetrackingTaskForm',
  },
  TIMETRACKER: {
    OVERVIEW: 'timetrackerOverview',
    DETAIL: 'timetrackerDetail',
    TIMETRACKING_DETAIL: 'timetrackerTimetrackingDetail',
    PLAY: 'timetrackerPlay',
    RESUME: 'timetrackerResume',
    RUNNING: 'timetrackerRunning',
  },
  TRIAL_DASHBOARD: {
    OVERVIEW: 'trialDashboard',
    CHANGE_FEATURES_DIALOG: 'changefeaturesDialog',
  },
  SUBSCRIPTION: {
    DETAIL: 'subscriptionDetail',
    OVERVIEW: 'subscriptionOverview',
    FORM: 'subscriptionForm',
  },
  USER: {
    PROFILE_VIEW: 'userProfilePage',
  },
  QUICK_ADD: 'quickAdd',
  QUOTATION: {
    CREATE_FORM: 'quotationForm',
    ADD_PRODUCT_FORM: 'addProductQuotationForm',
    OVERVIEW: 'quotationOverview',
    OVERVIEW_UNEXPECTED_ERROR_PAGE: 'quotationOverviewUnexpectedErrorPage',
    DETAIL_UNEXPECTED_ERROR_PAGE: 'quotationDetailUnexpectedErrorPage',
    DETAIL: 'quotationDetail',
    FILE_WIDGET: 'quotationFileWidget',
    FILE_WIDGET_EMPTY_STATE: 'quotationFileWidgetEmptyState',
    COLLAPSED_WIDGET: 'quotationContents.collapsedWidget',
    EXPANDED_WIDGET: 'quotationContents.expandedWidget',
    DETAIL_HEADER: 'quotationHeader',
    DETAIL_CONTENTS_WIDGET: 'quotationContentGrid',
    INVOICE_WIDGET: 'quotationInvoiceWidget',
    INVOICE_WIDGET_EMPTY_STATE: 'quotationInvoiceWidgetEmptyState',
    QUOTATION_BACKGROUND_INFO_WIDGET: 'quotationBackgroundInformationWidget',
    QUOTATION_RENAME_DIALOG: 'quotationRenameForm',
    QUOTATION_DELETE_DIALOG: 'quotationDeleteForm',
    QUOTATION_PREVIEW: 'quotationPreview',
    PROJECTS_WIDGET: 'quotationProjectWidget',
    PROJECTS_WIDGET_EMPTY_STATE: 'quotationProjectWidgetEmptyState',
    ACTIVITY_FEED: 'quotationActivityFeed',
    EXPIRY_UPSELL_DIALOG: 'quotationExpiryUpsellDialog',
    USE_EXISTING_QUOTATION_DIALOG: 'useExistingQuotationDialog',
    TEMPLATE_FORM: 'quotationTemplateForm',
  },
  FILE: {
    FILE_PREVIEW: 'filePreview',
  },
  MOBILE: {
    MOBILE_APP_SPLASH: 'mobileAppSplash',
  },
};

export const EVENTS = {
  BULK_TIMETRACKING: {
    ADDED: 'bulkTimeTracking.added',
    CHANGED_WEEKS: 'bulkTimeTracking.changedWeeks',
    SELECTED_SUBJECT: 'bulkTimeTracking.selectedSubject',
    STARTED_ADDING: 'bulkTimeTracking.startedAdding',
    STARTED_SELECTING_SUBJECT: 'bulkTimeTracking.startedSelectingSubject',
    TOGGLE_BILLABLE: 'bulkTimeTracking.toggledBillable',
    ACCEPTED_SUGGESTION: 'bulkTimeTracking.acceptedSuggestion',
    DISMISSED_SUGGESTION: 'bulkTimeTracking.dismissedSuggestion',
  },
  CALENDAR: {
    OPENED_DAY: 'calendar.openedDay',
    OPENED_WEEK: 'calendar.openedWeek',
    OPENED_MONTH: 'calendar.openedMonth',
    OPENED_TEAM: 'calendar.openedTeam',
  },
  CALL: {
    STARTED_ADDING: 'call.startedAdding',
    STARTED_ADDING_FROM_EMPTY_STATE: 'call.startedAddingFromEmptyState',
    ADDED: 'call.added',
    DELETED: 'call.deleted',
    STARTED_COMPLETING: 'call.startedCompleting',
    STARTED_EXPORTING: 'call.startedExporting',
    OPENED_DETAIL: 'call.openedDetail',
    CHANGED_RESULTS_PER_PAGE: 'call.changedResultsPerPage',
    STARTED_CHANGING_LIST_VIEW_SETTINGS: 'call.startedChangingListViewSettings',
    COMPLETED: 'call.completed',
    STARTED_SEARCHING: 'calls.searched',
    MARKED_AS_DONE: 'call.markedAsDone',
    STARTED_CHANGING_OWNER: 'call.startedChangingOwner',
    STARTED_DELETING_SEGMENT: 'call.startedDeletingSegment',
    STARTED_EDITING_SEGMENT: 'call.startedEditingSegment',
    STARTED_ADDING_SEGMENT: 'call.startedAddingSegment',
    OPENED_SEGMENT: 'call.openedSegment',
    COLLAPSED_WIDGET: 'call.collapsedWidget',
    EXPANDED_WIDGET: 'call.expandedWidget',
  },
  CK_EDITOR: {
    SOURCE_CODE_MENU_ITEM_CLICKED: 'ckEditor.sourceCodeMenuItem.clicked',
  },
  COMPANY_ENTITY: {
    ACTIVATED: 'companyEntity.activated',
    ADDED: 'companyEntity.added',
    DELETED: 'companyEntity.deleted',
    EDITED: 'companyEntity.edited',
    MADE_DEFAULT: 'companyEntity.madeDefault',
    SELECTED_DETAILS: 'companyEntity.selectedDetails',
    SELECTED_ADDRESS: 'companyEntity.selectedAddress',
    SELECTED_PAYMENT_INFORMATION: 'companyEntity.selectedPaymentInformation',
    SELECTED_LOGO: 'companyEntity.selectedLogo',
    STARTED_ADDING: 'companyEntity.startedAdding',
    STARTED_ADDING_TERMS: 'companyEntity.startedAddingTerms',
    STARTED_DELETING: 'companyEntity.startedDeleting',
    STARTED_EDITING: 'companyEntity.startedEditing',
    STARTED_TRYING_PACKAGE: 'companyEntity.startedTryingPackage',
    STARTED_UPLOADING_TERMS: 'companyEntity.startedUploadingTerms',
  },
  COMPANY: {
    ADDED: 'company.added',
    ADDING_FAILED: 'company.addingFailed',
    ANONYMISED: 'company.anonymised',
    CANCELLED_ANONYMISING: 'company.cancelledAnonymising',
    CANCELLED_RESTORING: 'company.cancelledRestoring',
    CHANGED_PREFERRED_INVOICING_CURRENCY: 'changedPreferredInvoicingCurrency',
    COLLAPSED_WIDGET: 'company.collapsedWidget',
    EXPANDED_WIDGET: 'company.expandedWidget',
    COLLAPSED_MULTILINE_WIDGET: 'company.collapsedMultiline',
    EXPANDED_MULTILINE_WIDGET: 'company.expandedMultiline',
    DEACTIVATED: 'company.deactivated',
    DISABLED_AUTOMATIC_INVOICING: 'company.disabledAutomaticInvoicing',
    ALLOWED_PREPAID_BILLING: 'company.allowedPrepaidBilling',
    EDITED: 'company.edited',
    EDITING_FAILED: 'company.editingFailed',
    ENABLED_AUTOMATIC_INVOICING: 'company.enabledAutomaticInvoicing',
    FILTERED_ACTIVITY_FEED: 'company.filteredActivityFeed',
    RESTORED: 'company.restored',
    STARTED_ADDING: 'company.startedAdding',
    STARTED_ADDING_INLINE: 'company.startedAddingInline',
    STARTED_ANONYMISING: 'company.startedAnonymising',
    STARTED_EDITING: 'company.startedEditing',
    STARTED_RESTORING: 'company.startedRestoring',
    STARTED_DEACTIVATING: 'company.startedDeactivating',
    STARTED_DELETING_SEGMENT: 'company.startedDeletingSegment',
    STARTED_EDITING_SEGMENT: 'company.startedEditingSegment',
    STARTED_ADDING_SEGMENT: 'company.startedAddingSegment',
    STARTED_UNLINKING_CONTACT: 'company.startedUnlinkingContact',
    STARTED_EDITING_LINKED_CONTACT: 'company.startedEditingLinkedContact',
    UNLINKED_CONTACT: 'company.unlinkedContact',
    STARTED_UNLINKING_COMPANY: 'company.startedUnlinkingCompany',
    UNLINKED_COMPANY: 'company.unlinkedCompany',
    STARTED_LINKING_COMPANY: 'company.startedLinkingCompany',
    STARTED_LINKING_COMPANY_FROM_EMPTY_STATE: 'company.startedLinkingCompanyFromEmptyState',
    STARTED_LINKING_CONTACT: 'company.startedLinkingContact',
    STARTED_LINKING_CONTACT_FROM_EMPTY_STATE: 'company.startedLinkingContactFromEmptyState',
    LINKED_COMPANY: 'company.linkedCompany',
    OPENED_EXTERNAL_MAP: 'company.openedExternalMap',
    STARTED_IMPORTING_FROM_FILE: 'company.startedImportingFromFile',
    STARTED_IMPORTING_VIA_MARKETPLACE: 'company.startedImportingViaMarketplace',
    STARTED_INVOICING_UNBILLED_TIME: 'company.startedInvoicingUnbilledTime',
    STARTED_EDITING_PREPAID_BILLING_SETTINGS: 'company.startedEditingPrepaidBillingSettings',
    STARTED_EXPORTING: 'company.startedExporting',
    OPENED_DETAIL: 'company.openedDetail',
    OPENED_SEGMENT: 'company.openedSegment',
    STARTED_MERGING: 'company.startedMerging',
    STARTED_PRINTING_LABELS: 'company.startedPrintingLabels',
    STARTED_CHANGING_SECOND_ACCOUNT_MANAGER: 'company.startedChangingSecondAccountManager',
    STARTED_CHANGING_ACCOUNT_MANAGER: 'company.startedChangingAccountManager',
    STARTED_ADDING_TAGS: 'company.startedAddingTags',
    STARTED_REMOVING_TAGS: 'company.startedRemovingTags',
    STARTED_DELETING: 'company.startedDeleting',
    CHANGED_RESULTS_PER_PAGE: 'company.changedResultsPerPage',
    STARTED_CHANGING_LIST_VIEW_SETTINGS: 'company.startedChangingListViewSettings',
    STARTED_SYNC_WITH_EXTERNAL_FILE_PLATFORM: 'company.startedSyncWithExternalFilePlatform',
    STARTED_SEARCHING: 'companies.searched',
    STARTED_FILTERING_ACTIVITY_FEED: 'company.startedFilteringActivityFeed',
    STARTED_TRACKING_EMAIL: 'company.startedTrackingEmail',
    STARTED_REACTIVATING: 'company.startedReactivating',
    STARTED_LOOKING_UP_BY_SIRET: 'company.startedLookingUpBySiret',
    STARTED_EDITING_MULTILINE_TEXT: 'company.startedEditingMultilineText',
    ADDED_NOTE: 'company.addedNote',
    STARTED_ADDING_NOTE: 'company.startedAddingNote',
    UPDATED_MULTILINE_TEXT: 'company.updatedMultilineText',
    STARTED_ADDING_FILE: 'company.startedAddingFile',
    REACTIVATED: 'company.reactivated',
    STARTED_CUSTOMIZING_PAGE: 'company.startedCustomizingPage',
    RESTORE_DEFAULT_VIEW: 'company.restoredDefaultView',
    SAVED_CUSTOM_VIEW: 'company.savedCustomView',
    CANCEL_CUSTOMIZING_PAGE: 'company.canceledCustomizingPage',
  },
  CONTACT: {
    ADDED: 'contact.added',
    ADDING_FAILED: 'contact.addingFailed',
    ANONYMISED: 'contact.anonymised',
    CANCELLED_ANONYMISING: 'contact.cancelledAnonymising',
    CANCELLED_RESTORING: 'contact.cancelledRestoring',
    COLLAPSED_WIDGET: 'contact.collapsedWidget',
    EXPANDED_WIDGET: 'contact.expandedWidget',
    COLLAPSED_MULTILINE_WIDGET: 'contact.collapsedMultiline',
    EXPANDED_MULTILINE_WIDGET: 'contact.expandedMultiline',
    ALLOWED_PREPAID_BILLING: 'contact.allowedPrepaidBilling',
    DEACTIVATED: 'contact.deactivated',
    DISABLED_AUTOMATIC_INVOICING: 'contact.disabledAutomaticInvoicing',
    EDITED: 'contact.edited',
    EDITING_FAILED: 'contact.editingFailed',
    ENABLED_AUTOMATIC_INVOICING: 'contact.enabledAutomaticInvoicing',
    FILTERED_ACTIVITY_FEED: 'contact.filteredActivityFeed',
    RESTORED: 'contact.restored',
    STARTED_ADDING: 'contact.startedAdding',
    STARTED_ANONYMISING: 'contact.startedAnonymising',
    STARTED_RESTORING: 'contact.startedRestoring',
    STARTED_DELETING_SEGMENT: 'contact.startedDeletingSegment',
    STARTED_EDITING_SEGMENT: 'contact.startedEditingSegment',
    STARTED_ADDING_SEGMENT: 'contact.startedAddingSegment',
    OPENED_EXTERNAL_MAP: 'contact.openedExternalMap',
    STARTED_IMPORTING_FROM_FILE: 'contact.startedImportingFromFile',
    STARTED_IMPORTING_VIA_MARKETPLACE: 'contact.startedImportingViaMarketplace',
    STARTED_INVOICING_UNBILLED_TIME: 'contact.startedInvoicingUnbilledTime',
    STARTED_EDITING_PREPAID_BILLING_SETTINGS: 'contact.startedEditingPrepaidBillingSettings',
    STARTED_EXPORTING: 'contact.startedExporting',
    OPENED_DETAIL: 'contact.openedDetail',
    OPENED_SEGMENT: 'contact.openedSegment',
    STARTED_DEACTIVATING: 'contact.startedDeactivating',
    STARTED_MERGING: 'contact.startedMerging',
    STARTED_PRINTING_LABELS: 'contact.startedPrintingLabels',
    STARTED_ADDING_TAGS: 'contact.startedAddingTags',
    STARTED_REMOVING_TAGS: 'contact.startedRemovingTags',
    STARTED_DELETING: 'contact.startedDeleting',
    STARTED_ADDING_TO_EVENT: 'contact.startedAddingToEvent',
    CHANGED_RESULTS_PER_PAGE: 'contact.changedResultsPerPage',
    STARTED_CHANGING_LIST_VIEW_SETTINGS: 'contact.startedChangingListViewSettings',
    STARTED_SYNC_WITH_EXTERNAL_FILE_PLATFORM: 'contact.startedSyncWithExternalFilePlatform',
    STARTED_SEARCHING: 'contacts.searched',
    STARTED_FILTERING_ACTIVITY_FEED: 'contact.startedFilteringActivityFeed',
    STARTED_TRACKING_EMAIL: 'contact.startedTrackingEmail',
    STARTED_REACTIVATING: 'contact.startedReactivating',
    STARTED_EDITING_MULTILINE_TEXT: 'contact.startedEditingMultilineText',
    UPDATED_MULTILINE_TEXT: 'contact.updatedMultilineText',
    ADDED_NOTE: 'contact.addedNote',
    STARTED_ADDING_NOTE: 'contact.startedAddingNote',
    STARTED_ADDING_FILE: 'contact.startedAddingFile',
    REACTIVATED: 'contact.reactivated',
    STARTED_CUSTOMIZING_PAGE: 'contact.startedCustomizingPage',
    RESTORE_DEFAULT_VIEW: 'contact.restoredDefaultView',
    SAVED_CUSTOM_VIEW: 'contact.savedCustomView',
    CANCEL_CUSTOMIZING_PAGE: 'contact.canceledCustomizingPage',
  },
  CREDIT_NOTE: {
    STARTED_ADDING: 'creditNote.startedAdding',
    STARTED_DELETING_SEGMENT: 'creditNote.startedDeletingSegment',
    STARTED_EDITING_SEGMENT: 'creditNote.startedEditingSegment',
    STARTED_ADDING_SEGMENT: 'creditNote.startedAddingSegment',
    STARTED_EXPORTING: 'creditNote.startedExporting',
    COLLAPSED_WIDGET: 'creditNote.collapsedWidget',
    EXPANDED_WIDGET: 'creditNote.expandedWidget',
    OPENED_DETAIL: 'creditNote.openedDetail',
    OPENED_SEGMENT: 'creditNote.openedSegment',
    CHANGED_RESULTS_PER_PAGE: 'creditNote.changedResultsPerPage',
    STARTED_CHANGING_LIST_VIEW_SETTINGS: 'creditNote.startedChangingListViewSettings',
    STARTED_SEARCHING: 'creditNotes.searched',
    STARTED_EXCEL_EXPORT: 'creditNote.startedExcelExport',
    STARTED_CSV_EXPORT: 'creditNote.startedCsvExport',
    STARTED_PDF_EXPORT: 'creditNote.startedPdfExport',
    SAVED_LIST_VIEW_SETTINGS: 'creditNote.savedListViewSettings',
  },
  CUSTOM_ACTIVITY_TYPE: {
    ADDED: 'customActivityType.added',
    EDITED: 'customActivityType.edited',
    ARCHIVED: 'customActivityType.archived',
  },
  CUSTOMER_MEETING: {
    CONTACT_FORMS: {
      CLICKED_EXPLORE_CONTACT_FORMS_BUTTON: 'contactForms.clickedExploreContactFormsButton',
      EXPLORE: 'contactForms.explore',
      STARTED_SETTING_UP: 'contactForms.startedSettingUp',
      STARTED_TRYING_CUSTOMER_MEETING_ADDON: 'contactForms.startedTryingCustomerMeetingAddon',
    },
    PROMOTIONAL_PAGE: {
      OPENED: 'customerMeetingPromotionalPage.opened',
      PLAYED_VIDEO: 'customerMeetingPromotionalPage.playedVideo',
      TRIAL_STARTED: 'license.startedTryingCustomerMeetingAddon',
      TRIAL_STARTED_FROM_DEALS: 'license.startedTryingCustomerMeetingAddonFromDeals',
    },
    STANDALONE: {
      OPENED: 'customerMeetingStandalone.opened',
    },
    FOOTER: {
      STARTED_UPGRADING: 'license.startedUpgradingCustomerMeetingAddon',
    },
  },
  DEAL: {
    ADDED: 'deal.added',
    ANONYMISED: 'deal.anonymised',
    CANCELLED_ANONYMISING: 'deal.cancelledAnonymising',
    CANCELLED_RESTORING: 'deal.cancelledRestoring',
    CLICKED_MULTIPLE_DEAL_PIPELINES_FAKE_DOOR: 'deal.clickedMultipleDealPipelinesFakeDoor',
    DEAL_CLICKED_MULTIPLE_DEAL_PIPELINES_TRY_NOW: 'deal.clickedMultipleDealPipelinesTryNow',
    DEAL_CLICKED_MULTIPLE_DEAL_PIPELINES_LEARN_MORE: 'deal.clickedMultipleDealPipelinesLearnMore',
    CLICKED_UNLIMITED_DEAL_PIPELINES_FAKE_DOOR: 'deal.clickedUnlimitedDealPipelinesFakeDoor',
    DEAL_CLICKED_UNLIMITED_DEAL_PIPELINES_TRY_NOW: 'deal.clickedUnlimitedDealPipelinesTryNow',
    DEAL_CLICKED_UNLIMITED_DEAL_PIPELINES_LEARN_MORE: 'deal.clickedUnlimitedDealPipelinesLearnMore',
    COLLAPSED_WIDGET: 'deal.collapsedWidget',
    EXPANDED_WIDGET: 'deal.expandedWidget',
    EDITED: 'deal.edited',
    FILTERED_ON_PIPELINE: 'deal.filteredOnPipeline',
    FILTERED_ON_STATUS: 'deal.filteredOnStatus',
    FILTERED_ON_PHASE: 'deal.filteredOnPhase',
    RESTORED: 'deal.restored',
    STARTED_ADDING: 'deal.startedAdding',
    STARTED_ADDING_FROM_EMPTY_STATE: 'deal.startedAddingFromEmptyState',
    STARTED_ANONYMISING: 'deal.startedAnonymising',
    STARTED_DELETING_SEGMENT: 'deal.startedDeletingSegment',
    STARTED_EDITING_SEGMENT: 'deal.startedEditingSegment',
    STARTED_ADDING_SEGMENT: 'deal.startedAddingSegment',
    STARTED_RESTORING: 'deal.startedRestoring',
    STARTED_EXPORTING: 'deal.startedExporting',
    OPENED_DETAIL: 'deal.openedDetail',
    OPENED_SEGMENT: 'deal.openedSegment',
    STARTED_CHANGING_PHASE: 'deal.startedChangingPhase',
    CHANGED_RESULTS_PER_PAGE: 'deal.changedResultsPerPage',
    STARTED_CHANGING_LIST_VIEW_SETTINGS: 'deal.startedChangingListViewSettings',
    STARTED_SEARCHING: 'deals.searched',
  },
  DEAL_PIPELINE: {
    ADDED: 'dealPipeline.added',
    DELETED: 'dealPipeline.deleted',
    EDITED: 'dealPipeline.edited',
    MARKED_AS_DEFAULT: 'dealPipeline.markedAsDefault',
    STARTED_ADDING: 'dealPipeline.startedAdding',
    STARTED_DELETING: 'dealPipeline.startedDeleting',
    STARTED_EDITING: 'dealPipeline.startedEditing',
    STARTED_MANAGING: 'dealPipeline.startedManaging',
  },
  DEAL_PHASE: {
    ADDED: 'dealPhase.added',
    CHANGED_ACTION_AUTOMATION: 'dealPhase.changedActionAutomation',
    CHANGED_COLOR: 'dealPhase.changedColor',
    CHANGED_NUMBER_OF_DAYS_BEFORE: 'dealPhase.changedNumberOfDaysBefore',
    DELETED: 'dealPhase.deleted',
    EDITED: 'dealPhase.edited',
    SET_DEFAULT_PROBABILITY: 'dealPhase.setDefaultProbability',
  },
  DELIVERY_NOTE: {
    STARTED_EXPORTING: 'deliveryNote.startedExporting',
    STARTED_DELETING_SEGMENT: 'deliveryNote.startedDeletingSegment',
    STARTED_EDITING_SEGMENT: 'deliveryNote.startedEditingSegment',
    STARTED_ADDING_SEGMENT: 'deliveryNote.startedAddingSegment',
    OPENED_DETAIL: 'deliveryNote.openedDetail',
    OPENED_SEGMENT: 'deliveryNote.openedSegment',
    CHANGED_RESULTS_PER_PAGE: 'deliveryNote.changedResultsPerPage',
    STARTED_CHANGING_LIST_VIEW_SETTINGS: 'deliveryNote.startedChangingListViewSettings',
    STARTED_SEARCHING: 'deliveryNotes.searched',
  },
  DOCUMENT_LINES: {
    CLOSED_ADD_ITEM_MENU: 'documentLines.ClosedAddItemMenu',
    OPENED_ADD_ITEM_MENU: 'documentLines.OpenedAddItemMenu',
    STARTED_ADDING_HEADER_ITEM: 'documentLines.StartedAddingHeaderItem',
    STARTED_ADDING_LINE_ITEM: 'documentLines.StartedAddingLineItem',
  },
  EXTERNAL_MEETING: {
    CONVERTED_TO_TASK: 'externalMeeting.convertedToTask',
    CONVERTED_TO_MEETING: 'externalMeeting.convertedToMeeting',
  },
  GLOBAL_SEARCH: {
    FOCUSED: 'header.search.focused',
  },
  GLOBAL_SEARCH_SURVEY: {
    OPENED: 'globalSearchSurvey.opened',
    SUBMITTED: 'globalSearchSurvey.submitted',
  },
  INSIGHTS: {
    PIPELINE: {
      CHANGED_COMPANY_ENTITY_VIEWED: 'insights.pipeline.changedCompanyEntityViewed',
    },
    INVOICES: {
      CHANGED_COMPANY_ENTITY_VIEWED: 'insights.invoices.changedCompanyEntityViewed',
    },
  },
  INTEGRATION: {
    OPENED_DETAIL: 'integration.openedDetail',
  },
  INTRO_VIDEO: {
    STARTED_WATCHING: 'introVideo.startedWatching',
  },
  INVITE: {
    CANCELLED_SENDING: 'invite.cancelledSending',
    STARTED_SENDING: 'invite.startedSending',
    SENT: 'invite.sent',
    STARTED_RESENDING: 'invite.startedResending',
    RESENT: 'invite.resent',
    STARTED_CANCELING: 'invite.startedCancelling',
    CANCELED: 'invite.cancelled',
  },
  INVOICE: {
    SAVED_DRAFT: 'invoice.savedDraft',
    DELETED_SECTION: 'invoice.deletedSection',
    ADDED_SECTION: 'invoice.addedSection',
    SELECTED_TAX: 'invoice.selectedTax',
    STARTED_SELECTING_TAX: 'invoice.startedSelectingTax',
    OPENED_DISCOUNT_RATE: 'invoice.openedDiscountRate',
    DELETED_LINE_ITEM: 'invoice.deletedLineItem',
    ADDED_LINE_ITEM: 'invoice.addedLineItem',
    RESET_RATE: 'invoice.resetRate',
    CHANGED_RATE: 'invoice.changedRate',
    STARTED_SELECTING_RATE: 'invoice.startedSelectingRate',
    SELECTED_CURRENCY: 'invoice.selectedCurrency',
    STARTED_SELECTING_CURRENCY: 'invoice.startedSelectingCurrency',
    SELECTED_PAYMENTS_TERMS: 'invoice.selectedPaymentTerms',
    STARTED_SELECTING_PAYMENT_TERMS: 'invoice.startedSelectingPaymentTerms',
    SELECTED_DATE: 'invoice.selectedDate',
    STARTED_SELECTING_DATE: 'invoice.startedSelectingDate',
    SELECTED_CUSTOMER: 'invoice.selectedCustomer',
    STARTED_SELECTING_CUSTOMER: 'invoice.startedSelectingCustomer',
    SELECTED_DEPARTMENT: 'invoice.selectedDepartment',
    STARTED_SELECTING_DEPARTMENT: 'invoice.startedSelectingDepartment',
    SELECTED_AN_INVOICE: 'invoice.selectedAnInvoice',
    DESELECTED_AN_INVOICE: 'invoice.deselectedAnInvoice',
    SELECTED_ALL_INVOICES: 'invoice.selectedAllInvoices',
    DESELECTED_ALL_INVOICES: 'invoice.deselectedAllInvoices',
    OPENED_INVOICE_DETAIL: 'invoice.openedInvoiceDetail',
    OPENED_PREVIOUS_PAGE: 'invoice.openedPreviousPage',
    OPENED_NEXT_PAGE: 'invoice.openedNextPage',
    STARTED_ADDING: 'invoice.startedAdding',
    STARTED_ADDING_FROM_EMPTY_STATE: 'invoice.startedAddingFromEmptyState',
    ADDED_DRAFT: 'invoice.addedDraft',
    ADDED_UNBILLED_TIME: 'invoice.addedUnbilledTime',
    EDITED_DRAFT: 'invoice.editedDraft',
    EDITED: 'invoice.edited',
    BOOKED_DRAFT: 'invoice.bookedDraft',
    BOOKED: 'invoice.booked',
    SENT: 'invoice.sent',
    STARTED_BOOKING_IN_BULK: 'invoice.startedBookingInBulk',
    BOOKED_IN_BULK: 'invoice.bookedInBulk',
    MARKED_AS_PAID: 'invoice.markedAsPaid',
    STARTED_MARKING_AS_PAID: 'invoice.startedMarkingAsPaid',
    STARTED_MARKING_AS_PAID_IN_BULK: 'invoice.startedMarkingAsPaidInBulk',
    MARKED_AS_PAID_IN_BULK: 'invoice.markedAsPaidInBulk',
    ADDED_PARTIAL_PAYMENT: 'invoice.addedPartialPayment',
    STARTED_DELETING_PAYMENT: 'invoice.startedDeletingPayment',
    STARTED_DELETED_PAYMENT: 'invoice.deletedPayment',
    STARTED_EDITING_PAYMENT: 'invoice.startedEditingPayment',
    CHANGED_CURRENCY: 'invoice.changedCurrency',
    CHANGED_CURRENCY_EXCHANGE_RATE: 'invoice.changedCurrencyExchangeRate',
    RESET_CURRENCY_EXCHANGE_RATE: 'invoice.resetCurrencyExchangeRate',
    STARTED_CONVERTING_CURRENCY: 'invoice.startedConvertingCurrency',
    CONVERTED_CURRENCY: 'invoice.convertedCurrency',
    STARTED_SELECTING_FILTER: 'invoice.startedSelectingFilter',
    SELECTED_FILTER: 'invoice.selectedFilter',
    STARTED_ADDING_EXTENDED_DESCRIPTION: 'invoice.startedAddingExtendedDescription',
    DELETED_EXTENDED_DESCRIPTION: 'invoice.deletedExtendedDescription',
    STARTED_CREATING_INVOICE_REPORT: 'invoice.startedCreatingInvoiceReport',
    CREATED_INVOICE_REPORT: 'invoice.createdInvoiceReport',
    STARTED_EXPORTING: 'invoice.startedExporting',
    OPENED_DETAIL: 'invoice.openedDetail',
    STARTED_DELETING_SEGMENT: 'invoice.startedDeletingSegment',
    STARTED_EDITING_SEGMENT: 'invoice.startedEditingSegment',
    STARTED_ADDING_SEGMENT: 'invoice.startedAddingSegment',
    OPENED_SEGMENT: 'invoice.openedSegment',
    CHANGED_RESULTS_PER_PAGE: 'invoice.changedResultsPerPage',
    STARTED_CHANGING_LIST_VIEW_SETTINGS: 'invoice.startedChangingListViewSettings',
    SAVED_LIST_VIEW_SETTINGS: 'invoice.savedListViewSettings',
    STARTED_SEARCHING: 'invoices.searched',
    STARTED_REQUESTING_FINANCING: 'invoice.startedRequestingFinancing',
    REQUESTED_FINANCING: 'invoice.requestedFinancing',
    TOGGLED_VISIBILITY_INVOICES_ELIGIBLE_FOR_FINANCING: 'invoice.toggledVisibilityInvoicesEligibleForFinancing',
    RETRIED_SENDING_FOR_FINANCING: 'invoice.retriedSendingForFinancing',
    STARTED_ADDING_PURCHASE_ORDER: 'invoice.startedAddingPurchaseOrder',
    STARTED_DELETING: 'invoice.startedDeleting',
    TOGGLED_STRICT_MODE: 'invoice.toggledStrictMode',
    COPIED_INVOICE_CLOUD_LINK: 'invoice.copiedInvoiceCloudLink',
    DOWNLOAD_TIME_TRACKING_REPORT: 'invoice.downloadTimeTrackingReport',
    SENT_THANK_YOU_MESSAGE: 'invoice.sentThankYouMessage',
    CHANGED_PAYMENT_DATE: 'invoice.changedPaymentDate',
    PAID_WITH_PAYMENT_METHOD: 'invoice.paidWithPaymentMethod',
    ADDED_PAYMENT_METHOD: 'invoice.addedPaymentMethod',
    CHANGED_PAYMENT_AMOUNT: 'invoice.changedPaymentAmount',
    CHANGED_PAYMENT_METHOD: 'invoice.changedPaymentMethod',
    STARTED_EXCEL_EXPORT: 'invoice.startedExcelExport',
    STARTED_CSV_EXPORT: 'invoice.startedCsvExport',
    STARTED_PDF_EXPORT: 'invoice.startedPdfExport',
    STARTED_BOOKKEEPING_EXPORT: 'invoice.startedBookkeepingExport',
    EXPORTED: 'invoice.exported',
    CANCELED_EXPORT: 'invoice.cancelledExport',
    STARTED_ADDING_COLUMNS_TEMPLATE: 'invoice.startedAddingColumnsTemplate',
    CLOSED_COLUMNS_TEMPLATE_EDITOR: 'invoice.closedColumnsTemplateEditor',
    ADDED_COLUMN_TEMPLATE: 'invoice.addedColumnsTemplate',
    EDITED_COLUMN_TEMPLATE: 'invoice.editedColumnsTemplate',
    STARTED_EDITING_COLUMNS_TEMPLATE: 'invoice.startedEditingColumnsTemplate',
    DELETED_COLUMNS_TEMPLATE: 'invoice.deletedColumnsTemplate',
    SELECTED_COLUMNS_TEMPLATE: 'invoice.selectedColumnsTemplate',
    COLLAPSED_WIDGET: 'invoice.collapsedWidget',
    EXPANDED_WIDGET: 'invoice.expandedWidget',
    ADDED: 'invoice.added',
  },
  LICENSE: {
    REQUESTED_SUBSCRIPTION_DOWNGRADE: 'license.requestedSubscriptionDowngrade',
    STARTED_REQUESTING_SUBSCRIPTION_DOWNGRADE: 'license.startedRequestingSubscriptionDowngrade',
    REQUESTED_SUBSCRIPTION_CANCELLATION: 'license.requestedSubscriptionCancellation',
    STARTED_REQUESTING_SUBSCRIPTION_CANCELLATION: 'license.startedRequestingSubscriptionCancellation',
    STARTED_ADDING_CREDIT_CARD: 'license.startedAddingCreditCard',
    CANCELLED_ADDING_CREDIT_CARD: 'license.cancelledAddingCreditCard',
    ADDED_CREDIT_CARD: 'license.addedCreditCard',
    OPENED: 'license.opened',
    DISCOVER_NEW_PACKAGES: 'license.discoverNewPackages',
    STARTED_BUYING_MORE_CUSTOMER_MEETING_ADDON_USERS: 'licence.startedBuyingMoreCustomerMeetingAddonUsers',
    STARTED_UPGRADING: 'license.startedUpgrading',
  },
  MARKETPLACE: {
    OPENED: 'marketplace.opened',
  },
  MEETING: {
    STARTED_ADDING: 'meeting.startedAdding',
    STARTED_ADDING_FROM_EMPTY_STATE: 'meeting.startedAddingFromEmptyState',
    ADDED: 'meeting.added',
    DELETED: 'meeting.deleted',
    EDITED: 'meeting.edited',
    DUPLICATED: 'meeting.duplicated',
    STARTED_EXPORTING: 'meeting.startedExporting',
    STARTED_DELETING: 'meeting.startedDeleting',
    OPENED_DETAIL: 'meeting.openedDetail',
    CHANGED_RESULTS_PER_PAGE: 'meeting.changedResultsPerPage',
    STARTED_CHANGING_LIST_VIEW_SETTINGS: 'meeting.startedChangingListViewSettings',
    STARTED_SEARCHING: 'meetings.searched',
    STARTED_DELETING_SEGMENT: 'meeting.startedDeletingSegment',
    STARTED_EDITING_SEGMENT: 'meeting.startedEditingSegment',
    STARTED_ADDING_SEGMENT: 'meeting.startedAddingSegment',
    OPENED_SEGMENT: 'meeting.openedSegment',
    CLICKED_ADD_CUSTOMER_MEETING_ROOM_BUTTON: 'meeting.clickedAddCustomerMeetingRoomButton',
    CLICKED_CUSTOMER_MEETING_ROOM_DROPDOWN: 'meeting.clickedCustomerMeetingRoomDropdown',
    SELECTED_CUSTOMER_MEETING_ROOM: 'meeting.selectedCustomerMeetingRoom',
    PREVIEWED_CUSTOMER_MEETING_ROOM: 'meeting.previewedCustomerMeetingRoom',
    CLEARED_CUSTOMER_MEETING_ROOM: 'meeting.clearedCustomerMeetingRoom',
    SEARCHING_CUSTOMER_MEETING_ROOM: 'meeting.searchingCustomerMeetingRoom',
    CREATED_CUSTOMER_MEETING_ROOM_FROM_SCRATCH: 'meeting.createdCustomerMeetingRoomFromScratch',
    CLOSED_INTERSTITIAL_DIALOG: 'meeting.closedInterstitialDialog',
    CLICKED_INTERSTITIAL_DIALOG_LEARN_MORE_BUTTON: 'meeting.clickedInterstitialDialogLearnMoreButton',
    CLICKED_INTERSTITIAL_DIALOG_LETS_GO_BUTTON: 'meeting.clickedInterstitialDialogLetsGoButton',
    COLLAPSED_WIDGET: 'meeting.collapsedWidget',
    EXPANDED_WIDGET: 'meeting.expandedWidget',
  },
  MILESTONE: {
    ADDED: 'milestone.added',
    CLOSED: 'milestone.closed',
    EDITED: 'milestone.edited',
    EXCEL_EXPORTED: 'milestone.excelExported',
    PDF_EXPORTED: 'milestone.pdfExported',
    STARTED_ADDING: 'milestone.startedAdding',
    STARTED_EDITING: 'milestone.startedEditing',
  },
  ORDER: {
    STARTED_ADDING: 'order.startedAdding',
    ADDED: 'order.added',
    STARTED_EDITING: 'order.startedEditing',
    EDITED: 'order.edited',
    EDITED_PROJECT: 'order.editedProject',
    EDITED_MILESTONE: 'order.editedMilestone',
    STARTED_EXPORTING: 'order.startedExporting',
    STARTED_DELETING_SEGMENT: 'order.startedDeletingSegment',
    STARTED_EDITING_SEGMENT: 'order.startedEditingSegment',
    STARTED_ADDING_SEGMENT: 'order.startedAddingSegment',
    OPENED_DETAIL: 'order.openedDetail',
    OPENED_SEGMENT: 'order.openedSegment',
    CHANGED_RESULTS_PER_PAGE: 'order.changedResultsPerPage',
    STARTED_CHANGING_LIST_VIEW_SETTINGS: 'order.startedChangingListViewSettings',
    STARTED_SEARCHING: 'orders.searched',
  },
  ORDER_CONFIRMATION: {
    STARTED_EXPORTING: 'orderConfirmation.startedExporting',
    STARTED_DELETING_SEGMENT: 'orderConfirmation.startedDeletingSegment',
    STARTED_EDITING_SEGMENT: 'orderConfirmation.startedEditingSegment',
    STARTED_ADDING_SEGMENT: 'orderConfirmation.startedAddingSegment',
    OPENED_SEGMENT: 'orderConfirmation.openedSegment',
    OPENED_DETAIL: 'orderConfirmation.openedDetail',
    CHANGED_RESULTS_PER_PAGE: 'orderConfirmation.changedResultsPerPage',
    STARTED_CHANGING_LIST_VIEW_SETTINGS: 'orderConfirmation.startedChangingListViewSettings',
    STARTED_SEARCHING: 'orderConfirmations.searched',
  },
  PAYMENT_METHODS: {
    ADDED: 'paymentMethod.added',
    DELETED: 'paymentMethod.deleted',
    EDITED: 'paymentMethod.edited',
  },
  PRODUCT: {
    STARTED_ADDING: 'product.startedAdding',
    ADDED: 'product.added',
    STARTED_IMPORTING_FROM_FILE: 'product.startedImportingFromFile',
    STARTED_IMPORTING_VIA_MARKETPLACE: 'product.startedImportingViaMarketplace',
    STARTED_EXPORTING: 'product.startedExporting',
    STARTED_DELETING_SEGMENT: 'product.startedDeletingSegment',
    STARTED_EDITING_SEGMENT: 'product.startedEditingSegment',
    STARTED_ADDING_SEGMENT: 'product.startedAddingSegment',
    OPENED_SEGMENT: 'product.openedSegment',
    OPENED_DETAIL: 'product.openedDetail',
    STARTED_DELETING: 'product.startedDeleting',
    CHANGED_RESULTS_PER_PAGE: 'product.changedResultsPerPage',
    STARTED_CHANGING_LIST_VIEW_SETTINGS: 'product.startedChangingListViewSettings',
    STARTED_SYNC_WITH_EXTERNAL_FILE_PLATFORM: 'product.startedSyncWithExternalFilePlatform',
    STARTED_SEARCHING: 'products.searched',
  },
  PROJECT: {
    ADDED: 'project.added',
    CHANGED_REPORT_TYPE_TO_TIMETRACKING: 'project.changedReportTypeToTimetracking',
    CHANGED_REPORT_TYPE_TO_EXTERNAL_COSTS: 'project.changedReportTypeToExternalCosts',
    CHANGED_REPORT_TYPE_TO_PDF: 'project.changedReportTypeToPdf',
    EXPORTED: 'project.exported',
    FILTERED_ACTIVITY_FEED: 'project.filteredActivityFeed',
    FILTERED_STATUS: 'project.filteredStatus',
    GENERATED_PROJECT_REPORT: 'project.generatedProjectReport',
    OPENED_DETAIL: 'project.openedDetail',
    STARTED_ADDING: 'project.startedAdding',
    STARTED_ADDING_FROM_EMPTY_STATE: 'project.startedAddingFromEmptyState',
    STARTED_EXPORTING: 'project.startedExporting',
    STARTED_EXCEL_EXPORTING: 'project.startedExcelExporting',
    STARTED_GENERATING_PROJECT_REPORT: 'project.startedGeneratingProjectReport',
    STARTED_DELETING_SEGMENT: 'project.startedDeletingSegment',
    STARTED_EDITING_SEGMENT: 'project.startedEditingSegment',
    STARTED_ADDING_SEGMENT: 'project.startedAddingSegment',
    OPENED_SEGMENT: 'project.openedSegment',
    TEMPLATE_SELECTED: 'project.templateSelected',
    TEMPLATE_UNSELECTED: 'project.templateUnselected',
    STARTED_ADDING_USER: 'project.startedAddingUser',
    CHANGED_RESULTS_PER_PAGE: 'project.changedResultsPerPage',
    STARTED_CHANGING_LIST_VIEW_SETTINGS: 'project.startedChangingListViewSettings',
    STARTED_SYNC_WITH_EXTERNAL_FILE_PLATFORM: 'project.startedSyncWithExternalFilePlatform',
    STARTED_SEARCHING: 'projects.searched',
    STARTED_FILTERING_ACTIVITY_FEED: 'project.startedFilteringActivityFeed',
    STARTED_TRACKING_EMAIL: 'project.startedTrackingEmail',
    STARTED_CLOSING: 'project.startedClosing',
    CLOSED: 'project.closed',
    REOPENED: 'project.reopened',
    STARTED_HIDING_ON_TIMELINE: 'project.startedHidingOnTimeline',
    STARTED_SHOWING_ON_TIMELINE: 'project.startedShowingOnTimeline',
    CANCELLED_HIDING_ON_TIMELINE: 'project.cancelledHidingOnTimeline',
    HIDDEN_ON_TIMELINE: 'project.hiddenOnTimeline',
    SHOWN_ON_TIMELINE: 'project.shownOnTimeline',
    CHANGED_VIEW: 'project.changedView',
    OPENED_WORK_BREAKDOWN: 'project.openedWorkBreakdown',
    COLLAPSED_WIDGET: 'project.collapsedWidget',
    EXPANDED_WIDGET: 'project.expandedWidget',
    UNLINKED_DEAL: 'project.unlinkedDeal',
    EDITED: 'project.edited',
    DELETED: 'project.deleted',
    STARTED_DELETING: 'project.startedDeleting',
    HIDE_HEADER: 'project.hideHeader',
    SHOW_HEADER: 'project.showHeader',
  },
  QUICK_FILTER: {
    APPLIED_RULE: 'quickFilter.appliedRule',
    CLEARED_RULE: 'quickFilter.clearedRule',
    CLEARED_ALL_RULES: 'quickFilter.clearedAllRules',
    REMOVED_RULE: 'quickFilter.removedRule',
    REMOVED_ALL_RULES: 'quickFilter.removedAllRules',
    SAVED: 'quickFilter.saved',
    STARTED_SAVING: 'quickFilter.startedSaving',
  },
  REFERRAL: {
    COPIED_LINK: 'referral.copiedLink',
    COPIED_LINK_MANUALLY: 'referral.copiedLinkManually',
    INVITED_BY_EMAIL: 'referral.invitedByEmail',
    OPENED_WALLET: 'referral.openedWallet',
    USED_AS_INVOICE_DISCOUNT: 'referral.usedAsInvoiceDiscount',
    USED_AS_CREDITS: 'referral.usedAsCredits',
  },
  SAVED_FILTER: {
    APPLIED_RULE: 'savedFilter.appliedRule',
    EDITED_FILTER_INFORMATION: 'savedFilter.editedFilterInformation',
    CLEARED: 'savedFilter.cleared',
    CLEARED_RULE: 'savedFilter.clearedRule',
    CLEARED_ALL_RULES: 'savedFilter.clearedAllRules',
    DELETED: 'savedFilter.deleted',
    REMOVED_RULE: 'savedFilter.removedRule',
    REMOVED_ALL_RULES: 'savedFilter.removedAllRules',
    SELECTED: 'savedFilter.selected',
    STARTED_DELETING: 'savedFilter.startedDeleting',
    STARTED_EDITING_FILTER_INFORMATION: 'savedFilter.startedEditingFilterInformation',
    STARTED_SAVING_AS: 'savedFilter.startedSavingAs',
    SAVED_AS: 'savedFilter.savedAs',
    SAVED_FILTER_CONTENT: 'savedFilter.savedFilterContent',
  },
  SEGMENTS: {
    STARTED_ADDING: 'segment.startedAdding',
    CREATED_SEGMENT: 'segment.created',
    STARTED_EDITING_SEGMENT: 'segment.startedEditing',
    EDITED_SEGMENT: 'segment.edited',
    STARTED_DELETING: 'segment.startedDeleting',
    DELETED: 'segment.deleted',
  },
  SETUP_WIZARD: {
    STARTED_CHANGING_LANGUAGE: 'setupWizard.startedChangingLanguage',
    CHANGED_LANGUAGE: 'setupWizard.changedLanguage',
    STARTED_CHANGING_COUNTRY: 'setupWizard.startedChangingCountry',
    CHANGED_COUNTRY: 'setupWizard.changedCountry',
    STARTED_CHANGING_TIMEZONE: 'setupWizard.startedChangingTimezone',
    CHANGED_TIMEZONE: 'setupWizard.changedTimezone',
    STARTED_CHANGING_CURRENCY: 'setupWizard.startedChangingCurrency',
    CHANGED_CURRENCY: 'setupWizard.changedCurrency',
    CONTINUED: 'setupWizard.continued',
    RETURNED: 'setupWizard.returned',
    SELECTED_MODULE: 'setupWizard.selectedModule',
    DESELECTED_MODULE: 'setupWizard.deselectedModule',
  },
  SUBSCRIPTION: {
    STARTED_ADDING: 'subscription.startedAdding',
    STARTED_ADDING_FROM_EMPTY_STATE: 'subscription.startedAddingFromEmptyState',
    STARTED_EXPORTING: 'subscription.startedExporting',
    STARTED_DELETING_SEGMENT: 'subscription.startedDeletingSegment',
    STARTED_EDITING_SEGMENT: 'subscription.startedEditingSegment',
    STARTED_ADDING_SEGMENT: 'subscription.startedAddingSegment',
    OPENED_SEGMENT: 'subscription.openedSegment',
    OPENED_DETAIL: 'subscription.openedDetail',
    CHANGED_RESULTS_PER_PAGE: 'subscription.changedResultsPerPage',
    STARTED_CHANGING_LIST_VIEW_SETTINGS: 'subscription.startedChangingListViewSettings',
    STARTED_SEARCHING: 'subscriptions.searched',
    COLLAPSED_WIDGET: 'subscription.collapsedWidget',
    EXPANDED_WIDGET: 'subscription.expandedWidget',
  },
  TASK: {
    STARTED_ADDING: 'task.startedAdding',
    STARTED_ADDING_FROM_EMPTY_STATE: 'task.startedAddingFromEmptyState',
    ADDED: 'task.added',
    DELETED: 'task.deleted',
    STARTED_EXPORTING: 'task.startedExporting',
    STARTED_DELETING_SEGMENT: 'task.startedDeletingSegment',
    STARTED_EDITING_SEGMENT: 'task.startedEditingSegment',
    STARTED_ADDING_SEGMENT: 'task.startedAddingSegment',
    OPENED_SEGMENT: 'task.openedSegment',
    OPENED_DETAIL: 'task.openedDetail',
    STARTED_CHANGING_OWNER: 'task.startedChangingOwner',
    STARTED_CHANGING_PRIORITY: 'task.startedChangingPriority',
    STARTED_CHANGING_DEADLINE: 'task.startedChangingDeadline',
    STARTED_CHANGING_TASK_TYPE: 'task.startedChangingTaskType',
    STARTED_CHANGING_CUSTOMER: 'task.startedChangingCustomer',
    STARTED_DELETING: 'task.startedDeleting',
    CHANGED_RESULTS_PER_PAGE: 'task.changedResultsPerPage',
    STARTED_CHANGING_LIST_VIEW_SETTINGS: 'task.startedChangingListViewSettings',
    STARTED_SCHEDULING: 'task.startedScheduling',
    STARTED_SEARCHING: 'tasks.searched',
    COLLAPSED_WIDGET: 'task.collapsedWidget',
    EXPANDED_WIDGET: 'task.expandedWidget',
    DUPLICATED: 'task.duplicated',
    EDITED: 'task.edited',
  },
  TICKET: {
    STARTED_ADDING: 'ticket.startedAdding',
    STARTED_ADDING_FROM_EMPTY_STATE: 'ticket.startedAddingFromEmptyState',
    STARTED_DELETING_SEGMENT: 'ticket.startedDeletingSegment',
    STARTED_EDITING_SEGMENT: 'ticket.startedEditingSegment',
    STARTED_ADDING_SEGMENT: 'ticket.startedAddingSegment',
    OPENED_SEGMENT: 'ticket.openedSegment',
    ADDED: 'ticket.added',
    OPENED_DETAIL: 'ticket.openedDetail',
    CHANGED_RESULTS_PER_PAGE: 'ticket.changedResultsPerPage',
    STARTED_CHANGING_LIST_VIEW_SETTINGS: 'ticket.startedChangingListViewSettings',
    STARTED_EXPORTING: 'ticket.startedExporting',
    STARTED_SEARCHING: 'tickets.searched',
    COLLAPSED_WIDGET: 'ticket.collapsedWidget',
    EXPANDED_WIDGET: 'ticket.expandedWidget',
  },
  TIMETRACKING: {
    ADDED: 'timetracking.added',
    CHANGED_USER: 'timetracking.changedUser',
    CLICKED_MULTIPLE_TIMETRACKING_FAKE_DOOR: 'timetracking.clickedMultipleTimetrackingFakeDoor',
    CLICKED_MULTIPLE_TIMETRACKING_TRY_NOW: 'timetracking.clickedMultipleTimetrackingTryNow',
    CLICKED_MULTIPLE_TIMETRACKING_REQUEST_FROM_ADMIN: 'timetracking.clickedMultipleTimetrackingRequestFromAdmin',
    CLICKED_MULTIPLE_TIMETRACKING_LEARN_MORE: 'timetracking.clickedMultipleTimetrackingLearnMore',
    EDITED: 'timetracking.edited',
    EXPORTED: 'timetracking.exported',
    OPENED_DAY_VIEW: 'timetracking.openedDayView',
    OPENED_DETAIL: 'timetracking.openedDetail',
    OPENED_MONTH_VIEW: 'timetracking.openedMonthView',
    OPENED_WEEK_VIEW: 'timetracking.openedWeekView',
    STARTED_ADDING: 'timetracking.startedAdding',
    STARTED_EDITING: 'timetracking.startedEditing',
    STARTED_DEDUCTING: 'timetracking.startedDeductingPrepaidCredits',
    DEDUCTED_CREDITS: 'timetracking.deductedPrepaidCredits',
    STARTED_MOVING: 'timetracking.startedMoving',
    STARTED_MARKING_AS_UNBILLED: 'timetracking.startedMarkingAsUnbilled',
    MARKED_AS_UNBILLED: 'timetracking.markedAsUnbilled',
    STARTED_EXCEL_EXPORTING: 'timetracking.startedExcelExporting',
    STARTED_EXPORTING: 'timetracking.startedExporting',
    STARTED_PDF_EXPORTING: 'timetracking.startedPdfExporting',
    VIEWED_BACK: 'timetracking.viewedBack',
    VIEWED_NEXT: 'timetracking.viewedNext',
    VIEWED_TODAY: 'timetracking.viewedToday',
    OPENED_TRACKER: 'timetracking.openedTracker',
    CLOSED_TRACKER: 'timetracking.closedTracker',
    OPENED_TIMER_DETAIL: 'timetracking.openedTimerDetail',
    OPENED_TIMETRACKING_DETAIL: 'timetracking.openedTimetrackingDetail',
    CLOSED_DETAIL: 'timetracking.closedDetail',
    SAVED: 'timetracking.saved',
    STARTED: 'timetracking.startedAdding',
    STOPPED: 'timetracking.added',
    COLLAPSED_WIDGET: 'timetracking.collapsedWidget',
    EXPANDED_WIDGET: 'timetracking.expandedWidget',
  },
  CHANGE_FEATURES: {
    STARTED_CHANGING_FEATURES: 'changeFeatures.startedChangingFeatures',
    CANCELED_CHANGE_FEATURES: 'changeFeatures.canceledChangeFeatures',
    APPLIED_CHANGE_FEATURES: 'changeFeatures.appliedChangeFeatures',
  },
  QUOTATION: {
    STARTED_ADDING: 'quotation.startedAdding',
    SORTED_ON_COLUMN: 'quotation.sortedOnColumn',
    FILTERED_ON_STATUS: 'quotation.filteredOnStatus',
    FILTERED_ON_ASSIGNEE: 'quotation.filteredOnAssignee',
    ADDED: 'quotation.added',
    SEARCHED: 'quotation.searched',
    STARTED_EDITING: 'quotation.startedEditing',
    EDITED: 'quotation.edited',
    SAVED_AS_TEMPLATE: 'quotation.savedAsTemplate',
    CLOSED: 'quotation.closed',
    STARTED_ADDING_ATTACHMENT: 'quotation.startedAddingAttachment',
    GO_BACK_CLICKED: 'quotation.goBackClicked',
    STARTED_SAVING: 'quotation.startedSaving',
    CREATE_QUOTATION_DIALOG_CLOSED: 'quotation.createQuotationDialog.closed',
    VIEWED_MARGIN_CALCULATION: 'quotation.checkedMarginCalculation',
    VIEWED_CLOUD_SIGN_ACTIVITY: 'quotation.viewedActivity',
    VIEWED_VERSION_HISTORY: 'quotation.viewedVersionHistory',
    STARTED_CHANGING_LIST_VIEW_SETTINGS: 'quotation.startedChangingListViewSettings',
    SAVED_LIST_VIEW_SETTINGS: 'quotation.savedListViewSettings',
    COLLAPSED_WIDGET: 'quotation.collapsedWidget',
    EXPANDED_WIDGET: 'quotation.expandedWidget',
    EXPANDED_CONTENT_WIDGET: 'quotation.expandedContentGrid',
    COLLAPSED_CONTENT_WIDGET: 'quotation.collapsedContentGrid',
    OPENED_DETAIL: 'quotation.openedDetail',
    STARTED_ADDING_FROM_EMPTY_STATE: 'quotation.startedAddingFromEmptyState',
    COPIED_LINK_SHORT_CODE: 'quotation.copiedLinkShortCode',
    SENT: 'quotation.sent',
    REFUSED: 'quotation.refused',
    ACCEPTED: 'quotation.accepted',
    PREVIEW: 'quotation.previewed',
    MADE_AVAILABLE: 'quotation.madeAvailableOnCloudsign',
    MADE_UNAVAILABLE: 'quotation.madeUnavailableOnCloudsign',
    OPENED_PREVIEW: 'quotation.openedPreviewOnCloudsign',
    DOWNLOADED: 'quotation.downloaded',
    CLICKED_COPY_LINK: 'quotation.clickedCopyLink',
    UPDATED_LAYOUT: 'quotation.updatedLayout',
    VIEWED_DETAIL: 'quotation.viewedDetail',
    OPENED_FOLLOWUP: 'quotation.openedFollowUp',
    SHOW_DETAILS: 'quotation.showDetails',
    HIDE_DETAILS: 'quotation.hideDetails',
    STARTED_RENAMING: 'quotation.startedRenaming',
    STARTED_COPYING: 'quotation.startedCopying',
    STARTED_DELETING: 'quotation.startedDeleting',
    STARTED_SENDING: 'quotation.startedSending',
    STARTED_PRINTING: 'quotation.startedPrinting',
    STARTED_CUSTOMISING_HEADER: 'quotation.startedCustomisingHeader',
    SAVED_BACKGROUND_INFO: 'quotation.savedBackgroundInformation',
    STARTED_ADDING_BACKGROUND_INFO: 'quotation.startedAddingBackgroundInformation',
    STARTED_EDITING_BACKGROUND_INFO: 'quotation.startedEditingBackgroundInformation',
    EXPANDED_BACKGROUND_INFO: 'quotation.expandedBackgroundInformation',
    COLLAPSED_BACKGROUND_INFO: 'quotation.collapsedBackgroundInformation',
    EXPANDED_INVOICE_WIDGET: 'quotation.expandedInvoiceWidget',
    COLLAPSED_INVOICE_WIDGET: 'quotation.collapsedInvoiceWidget',
    EXPANDED_FILE_WIDGET: 'quotation.expandedFileWidget',
    COLLAPSED_FILE_WIDGET: 'quotation.collapsedFileWidget',
    EXPANDED_PROJECT_WIDGET: 'quotation.expandedProjectWidget',
    COLLAPSED_PROJECT_WIDGET: 'quotation.collapsedProjectWidget',
    RETURNED_TO_OVERVIEW: 'quotation.returnedToOverviewPage',
    RENAMED: 'quotation.renamed',
    DELETED: 'quotation.deleted',
    STARTED_UPDATING_LAYOUT: 'quotation.startedUpdatingLayout',
    FILTERED_ACTIVITY_FEED: 'quotation.filteredActivityFeed',
    STARTED_ADDING_FILE: 'quotation.startedAddingFile',
    ADDED_NOTE: 'quotation.addedNote',
    STARTED_ADDING_NOTE: 'quotation.startedAddingNote',
    STARTED_TRACKING_EMAIL: 'quotation.startedTrackingEmail',
    DISMISSED_EXPIRY_BANNER: 'quotation.dismissedQuotationExpiryBanner',
    STARTED_SENDING_REMINDER: 'quotation.startedSendingReminder',
    CLICKED_EXPIRY_DATE_FAKE_DOOR: 'quotation.clickedExpiryDateFakeDoor',
    CLICKED_EXPIRY_DATE_TRY_NOW: 'quotation.clickedExpiryDateTryNow',
    CLICKED_EXPIRY_DATE_LEARN_MORE: 'quotation.clickedExpiryDateLearnMore',
  },
  USER: {
    STARTED_DEACTIVATING: 'user.startedDeactivating',
    STARTED_EDITING: 'user.startedEditing',
    EDITED: 'user.edited',
    PROVIDED_ADMIN_RIGHTS: 'user.providedAdminRights',
    REVOKED_ADMIN_RIGHTS: 'user.revokedAdminRights',
    STARTED_CHANGING_PASSWORD: 'user.startedChangingPassword',
    STARTED_SETTING_PASSWORD: 'user.startedSettingPassword',
    STARTED_UNLINKING_ACCOUNT: 'user.startedUnlinkingAccount',
    UNLINKED_ACCOUNT: 'user.unlinkedAccount',
    STARTED_LINKING_ACCOUNT: 'user.startedLinkingAccount',
    LINKED_ACCOUNT: 'user.linkedAccount',
    CUSTOMER_MEETING_ACCESS_CHANGED: 'user.customerMeetingAccessChanged',
    LOGGED_OUT_ALL: 'users.loggedOutAll',
    STARTED_DELETING: 'user.startedDeleting',
    DELETED: 'user.deleted',
    STARTED_VIEWING_REPORT: 'user.startedViewingReport',
  },
  WORKORDER: {
    OPENED_DETAIL: 'workOrder.openedDetail',
    STARTED_ADDING: 'workOrder.startedAdding',
    STARTED_EDITING: 'workOrder.startedEditing',
    EDITED: 'workOrder.edited',
    ADDED: 'workOrder.added',
  },
  ROUTING: {
    REDIRECT: 'routing.redirect',
  },
  KNOWLEDGE_BASE: {
    OPENED: 'knowledgeBase.opened',
  },
  GROUP: {
    STARTED_ADDING: 'group.startedAdding',
    STARTED_DELETING: 'group.startedDeleting',
    ADDED: 'group.added',
    DELETED: 'group.deleted',
    DUPLICATED: 'group.duplicated',
    EDITED: 'group.edited',
  },
  MATERIAL: {
    STARTED_ADDING: 'material.startedAdding',
    STARTED_DELETING: 'material.startedDeleting',
    ADDED: 'material.added',
    DELETED: 'material.deleted',
    DUPLICATED: 'material.duplicated',
    EDITED: 'material.edited',
  },
  PROJECT_LINE: {
    STARTED_BULK_DELETING: 'projectLine.startedBulkDeleting',
    BULK_DELETED: 'projectLine.bulkDeleted',
    BULK_DUPLICATED: 'projectLine.bulkDuplicated',
  },
  COLUMN: {
    ADDED: 'column.added',
    REMOVED: 'column.removed',
    SORTED: 'column.sorted',
  },
  GROUPS: {
    MERGED: 'groups.merged',
  },
  SECTION: {
    EXPANDED: 'section.expanded',
    COLLAPSED: 'section.collapsed',
  },
  HEADER_FIELD: {
    ADDED: 'headerField.added',
    REMOVED: 'headerField.removed',
  },
  USER_PROFILE: {
    STARTED_MAKING_EMAIL_PRIMARY: 'userProfile.startedMakingEmailPrimary',
    CONFIRMED_MAKING_EMAIL_PRIMARY: 'userProfile.confirmedMakingEmailPrimary',
    CANCELLED_MAKING_EMAIL_PRIMARY: 'userProfile.cancelledMakingEmailPrimary',
    STARTED_REMOVING_EMAIL: 'userProfile.startedRemovingEmail',
    CANCELLED_REMOVING_EMAIL: 'userProfile.cancelledRemovingEmail',
    CONFIRMED_REMOVING_EMAIL: 'userProfile.confirmedRemovingEmail',
    SUBMITTED_EMAIL: 'userProfile.submittedEmail',
    STARTED_EDITING_EMAIL: 'userProfile.startedEditingEmail',
    EDITED_EMAIL: 'userProfile.editedEmail',
  },
  FILE: {
    VIEWED_HISTORY: 'file.viewedHistory',
  },
  EMAIL: {
    STARTED_SENDING: 'email.startedSending',
  },
  MOBILE: {
    LOADED_MOBILE_APP_SPLASH: 'mobile.loadedMobileAppSplash',
    CLICKED_DOWNLOAD_BUTTON: 'mobile.clickedDownloadButton',
    CLICKED_SKIP_DOWNLOAD_BUTTON: 'mobile.clickedSkipDownloadButton',
  },
  SECURITY: {
    STARTED_ACTIVATING_ACCOUNT_MFA: 'security.startedActivatingAccountMfa',
    ACTIVATED_ACCOUNT_MFA: 'security.activatedAccountMfa',
    STARTED_DEACTIVATING_ACCOUNT_MFA: 'security.startedDeactivatingAccountMfa',
    DEACTIVATED_ACCOUNT_MFA: 'security.deactivatedAccountMfa',
    STARTED_ENFORCING_USER_MFA: 'security.startedEnforcingUserMfa',
    ENFORCED_USER_MFA: 'security.enforcedUserMFA',
    STARTED_DEACTIVATING_USER_MFA: 'security.startedDeactivatingUserMfa',
    DEACTIVATED_USER_MFA: 'security.deactivatedUserMfa',
    STARTED_RESETTING_PASSWORD: 'security.startedResettingPassword',
    RESET_PASSWORD: 'security.resetPassword',
    CLICKED_MFA_ENFORCEMENT_TRY_NOW: 'security.clickedMfaEnforcementTryNow',
  },
};
